import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { EmailRegex } from '@airasia-common/libraries/validation/Validator';
import { Variant } from '../../utils/constants';
import useForm from '../../utils/useForm';
import TextInputValidator from '../TextInput/TextInputValidator';
import Wrapper from '../Wrapper';
import { BodyText } from '../Text/Heading';
import { searchInputProps } from './LoyaltyPointSearch.propTypes';

const SearchButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  height: 24px;
  padding: 1px 0;
  background: white;
  border: 0;
  cursor: pointer;
`;

const fieldName = 'email';
const SearchInput = props => {
  const {
    label,
    searchLabel,
    onSearchClick,
    invalidError,
    customError,
    initialValue,
    move,
  } = props;
  const [errorMsg, setErrorMsg] = useState('');

  const validationSchema = {
    [fieldName]: {
      pattern: {
        value: EmailRegex,
        message: invalidError,
        validateOnChange: false,
      },
      optional: true,
    },
  };
  const { resetForm, createValidationProps, handleSubmit } = useForm(
    { [fieldName]: initialValue },
    validationSchema,
    {}
  );
  const inputProps = {
    label,
    placeholder: label,
    onFocus: () => setErrorMsg(''),
    ...createValidationProps(fieldName),
    inputProps: { width: 'calc(100% - 40px)' },
  };

  useEffect(() => {
    setErrorMsg(customError);
  }, [customError]);

  useEffect(() => {
    if (initialValue === '') {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  if (errorMsg) {
    inputProps.errorMsg = errorMsg;
    inputProps.variant = Variant.Error;
  }
  const searchHandler = useCallback(
    values => onSearchClick(values[fieldName]),
    [onSearchClick]
  );

  return (
    <Wrapper mt={[4, 5]} position="relative">
      <TextInputValidator {...inputProps} hideIcon move={move} />
      <SearchButton onClick={() => handleSubmit(searchHandler)}>
        <BodyText color={move ? 'tertiaryRed' : 'secondary'} lineHeight={1.25}>
          {searchLabel}
        </BodyText>
      </SearchButton>
    </Wrapper>
  );
};

SearchInput.propTypes = searchInputProps;
SearchInput.defaultProps = { customError: '', initialValue: '' };

export default SearchInput;
